webpackJsonp([227756093279661],{

/***/ 1550:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"RevenueCenterBudgetInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"appointments","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"month","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"revenue","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"revenueCenterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"revenuePerAppointment","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"year","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-revenue-center-budget-input-4263b53c7530f30c64cb.js